import { getSpacingBucket } from './payment-spacing';
import { policyTypeByLine } from './payment-schedule-viewed';

export const BILLING_DAY_CHANGED = 'Billing Day Changed';
export const CLOSE_PAYMENTS_RESOLUTION_SELECTED = 'Close Payments Resolution Selected';

const agencyProperties = (session) => ({
  isAgency: Boolean(session?.isAgency),
  agencyId: session?.user?.affinityCode ?? null
});

/**
 * Properties for `Billing Day Changed` (#36361), sent when the agent saves a billing day other than the
 * policy's default. `daysBetweenFirstTwoPayments` comes from the previewed schedule with the payments kept
 * separate, so it and `spacingBucket` are null when the preview didn't load.
 */
export const getBillingDayChangedProperties = ({
  policy,
  offerId,
  previousBillingDay,
  newBillingDay,
  daysBetweenFirstTwoPayments,
  state,
  session
}) => ({
  offerId,
  policyType: policyTypeByLine[policy.key] ?? null,
  previousBillingDay: previousBillingDay ? Number(previousBillingDay) : null,
  newBillingDay,
  daysBetweenFirstTwoPayments: daysBetweenFirstTwoPayments ?? null,
  spacingBucket: getSpacingBucket(daysBetweenFirstTwoPayments),
  ...agencyProperties(session),
  state: state ?? null
});

// Properties for `Close Payments Resolution Selected` (#36361), sent when the agent picks keep separate or
// combine for payments under 15 days apart.
export const getCloseResolutionProperties = ({ policy, offerId, resolution, daysApart, session }) => ({
  offerId,
  policyType: policyTypeByLine[policy.key] ?? null,
  resolution,
  daysApart,
  ...agencyProperties(session)
});
